export const ReportPageScreenMapping = {
  ReportOverviewPageRecord: 'OverviewScreen',
  ReportResultsPageRecord: 'ResultsScreen',
  ReportDetailsPageRecord: 'DetailsScreen',
  ReportResourcesPageRecord: 'ResourcesScreen',
  ReportRecommendationsPageRecord: 'RecommendationsScreen',
};
